module.exports = __webpack_public_path__ + "themeforest.jpg?b6d135509d34a27acc21103d52f2991d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/themeforest.jpg
// module id = 56
// module chunks = 0